import './ListItem.scss';

import { NonBreakableSpace } from 'components';
import React from 'react';

interface Props {
  title?: React.ReactNode;
  description?: string;
  selected?: boolean;
  onClick?: () => void;
  children?: any;
  actions?: React.ReactNode;
  nonBreakableSpace?: boolean;
  customClassName?: string;
}

const ListItem = (props: Props) => {
  const {
    selected,
    onClick,
    title,
    description,
    children,
    actions,
    nonBreakableSpace,
    customClassName
  } = props;
  return (
    <div
      className={`ListItem${selected ? ' selected' : ''}${!title ? ' without-title' : ''} ${
        customClassName || ''
      }`}
      onClick={onClick}
    >
      <div className="ListItem_selector">
        <div className="ListItem_inner">
          {title && (
            <div className="ListItem_title-container">
              <div>
                <div className="ListItem_title">{title}</div>
                <div className="ListItem_title-description">
                  {description || (nonBreakableSpace && <NonBreakableSpace />)}
                </div>
              </div>
              {actions && <div>{actions}</div>}
            </div>
          )}
          {children && <div className="ListItem_children">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default ListItem;
